import React from 'react';
import { isArray } from 'lodash';
import Marzipano from 'marzipano';

import { Themes } from './types';

export function createScene(panoElement, theme=Themes.Room2) {
  const viewer = new Marzipano.Viewer(panoElement);

  const source = Marzipano.ImageUrlSource.fromString(theme.src);

  const geometry = new Marzipano.EquirectGeometry([{ width: theme.imageWidth }]);

  // 3rd param of limiter seems to directly impact FOV
  const limiter = Marzipano.RectilinearView.limit.traditional(1024, 100*Math.PI/180, 100*Math.PI/180);
  const view = new Marzipano.RectilinearView({ pitch: 0, yaw: 0 }, limiter);

  const scene = viewer.createScene({
    source,
    geometry,
    view,
    pinFirstLevel: true
  });

  return scene;
}


export function getChildList(children=[]) {
  const childArray = isArray(children)? children : [children];
  // const refList = [];
  
  const  filteredChildArray = childArray.filter((child, index) => {
    // const childProps = keys(child.props); //Todo: implement a prop check
    return true;
  });

  const enchancedChildren = filteredChildArray.map((child, index) => {
    const ref = React.createRef();
    return React.cloneElement(child, { ref, key: index });
  });

  return enchancedChildren;
}